
import { Options, Vue } from "vue-class-component";
import PromotionalSMSService from "../../service/PromotionalSMSService.js";
import SmsService from "../../service/SmsService.js";
import Toaster from "../../helpers/Toaster";
import PromotionalSMSDialog from "../../components/PromotionalSMSDialog.vue";
import SMSPackageDialog from "../../components/SMSPackageDialog.vue";
import { watch } from 'vue';
import { promotionUpdateStatus } from '../../state/promotionState.js';

// Define SmsPackage interface
interface SmsPackage {
  package_id: number;
  sms_count: number;
  usage: number;
  activated_date: string;
  status: string;
}

@Options({
  title: 'Promotional SMS',
  components: {
    PromotionalSMSDialog,
    SMSPackageDialog,
  },
})



export default class PromotionalSMS extends Vue {
  private lists = [];
  private keyword = "";
  private dialogTitle = "";
  private smsUsageForCurrentPromotion = 0;
  private statusType = "New";
  private toast;
  private profilerID = 0;
  private currentUserID = 0;
  private promotionId = 0;
  private goToFirstLink = 0;
  private promotionalSMSService;
  private SmsService;
  private slotpropData;
  private checkPagination = true;
  private profileStatus = false;
  private popupDialog = false;
  private popupDialogText = "";
  private smsSendConfirm = false;
  private smsPackagesDialogVisible = false; 
  private smsPackages: SmsPackage[] = [];
  private contactNumbersCount = 0;
  private activePackagesArray: { key1: number; key2: number ; key3: number}[] = [];
  private usedPackagesArray: { key1: number; key2: number; key3: string}[] = [];
  private totalRecords = 0;
  private limit = 0;
  
  private home = { icon: "pi pi-home", to: "/" };
  private items = [
    { label: "Initialization", to: "/home/initialization" },
    { label: "Promotional SMS", to: "promotional-sms" },
  ];

  private item = {
    id: 0,
    accountTitle: "",
    status: "Active 3",
  };

  private totalSMSCount = 0;
  private totalRemainingSMSQuota = 0;
  private totalUsage = 0;
  private activePackagesCount = 0;

  openSMSPackagesDialog() {
    this.smsPackagesDialogVisible = true;
    this.loadSMSPackages();
  }

  openDialog() {
    this.dialogTitle = "Create New Promotional SMS";
    this.profileStatus = true;
    this.statusType = "New";
  }

  // Method to fetch data from sms_packages table
  private async loadSMSPackages() {
    try {
      this.smsPackages = await this.promotionalSMSService.getSMSPackages();
      this.calculateSummary(); // Calculate the summary after loading the data
    } catch (error) {
     
      this.toast.add({ severity: 'error', summary: 'Error', detail: 'Failed to load SMS packages' });
    }
  }

  
  // Method to calculate the summary based on loaded data
  private calculateSummary() {
    this.totalSMSCount = 0;
    this.totalUsage = 0;
    this.activePackagesCount = 0;
    this.totalRemainingSMSQuota = 0;
    this.smsPackages.forEach((packageData) => {
      this.totalSMSCount += packageData.sms_count;

      if (packageData.status === 'active') {
        this.activePackagesCount++;
        let packageRemaining = packageData.sms_count - packageData.usage;
        this.activePackagesArray.push({ key1: packageData.package_id, key2: packageRemaining , key3: packageData.usage});
        this.totalRemainingSMSQuota += packageRemaining;
        
      }
      this.totalUsage += packageData.usage;
    });
  }

  onPage(event) {
    this.loadList(event.first);
    
  }
  checkDeliveryStatusesOnPage(data) {
      data.forEach((item) => {
        if (item.status == "pending") {
          
          this.loadCampainStatus(item);
        }else if (item.status == "") {
          
          //this.loadCampainStatus(item);
        }
      });
  }

  created() {
    this.promotionalSMSService = new PromotionalSMSService();
    this.SmsService = new SmsService();
    this.toast = new Toaster();

    // Watch the reactive object for updates
    watch(promotionUpdateStatus, (newVal) => {
      if (newVal) {
        this.handleServiceUpdate(newVal); // Call method to process updates
      }
    });
  }



  mounted() {
    this.loadList(0);
    this.loadSMSPackages();
  }

  private handleServiceUpdate(data) {
    this.loadList(0);
  }


  loadList(page) {
    this.promotionalSMSService.getItems(this.keyword, page).then((data) => {
      this.lists = data.records;
      this.totalRecords = data.totalRecords;
      this.limit = data.limit;
      this.currentUserID = data.currentUserID;
      this.promotionId = 0;
      this.checkDeliveryStatusesOnPage(this.lists); 
    });
    
  }

  loadSearchData() {
    if (this.keyword) {
      this.goToFirstLink = 0;
      this.loadList(0);
    }
  }

  updatePromotionStatus(res) {
    this.profileStatus = false;
    if (res[0] === "load") {
      this.loadList(this.goToFirstLink);
    }
  }

  get totalRemainingSMS() {
    
    return this.totalRemainingSMSQuota;
  }
  private findUsedPackages(usageAmount) {
  let newUsage = usageAmount;
  let activePackagesCount = this.activePackagesArray.length
  for (let index = 0; index < activePackagesCount; index++) {
    let usageOfPackage = 0;
    if (this.activePackagesArray[index].key2 >= newUsage) {
      usageOfPackage = this.activePackagesArray[index].key3 + newUsage;
      
      if(this.activePackagesArray[index].key2 > newUsage){
        this.usedPackagesArray.push({ key1: this.activePackagesArray[index].key1, key2: usageOfPackage ,key3:"active"});
      }else{
        this.usedPackagesArray.push({ key1: this.activePackagesArray[index].key1, key2: usageOfPackage ,key3:"inactive"});
      }
      break;
    }else if(this.activePackagesArray[index].key2 > 0){
      newUsage -= this.activePackagesArray[index].key2;
      usageOfPackage = this.activePackagesArray[index].key3 + this.activePackagesArray[index].key2;
      this.usedPackagesArray.push({ key1: this.activePackagesArray[index].key1, key2: usageOfPackage ,key3:"inactive"});

    }else{
    }

  }
}

private getCurrentUsageForPromo(data){
  let smsesPerNumber = data.message.length <= 160 ? 1 : 2;
  this.smsUsageForCurrentPromotion = smsesPerNumber * data.contacts.length;
}

private sendSMSFromUI(data){
  if (!data.sending) {
        data.sending = true; // Temporarily disable the button
      }
  let contactNumbers = data.contacts.map(contact => contact.contact_number).join(',');
  const payload = {
			msisdn: contactNumbers, // Ensure this is correctly populated with the phone number
			mask: data.mask_type,      // Set the mask type correctly
			message: data.message,       // Message content
			type: "Promotional"   
		};
      
    if (this.hasInsufficientSMSBalance()) {
      
      
        this.promotionalSMSService.sendSMS(payload,data.id)
        .then((res) => {
          this.updatePackage(this.smsUsageForCurrentPromotion);
          data.sending = false;
        })
        .catch((e) => {
          
        }).finally(() => {
            // Optionally reset the `sending` state after completion
            
        });
        this.smsSendConfirm = false;
      
      
    } else {
     // this.toast.showError("SMS quota is insufficient.");
      
    }
}
hasInsufficientSMSBalance(){
  let balance = this.totalRemainingSMS >= this.smsUsageForCurrentPromotion;
  return balance;
}
openPopupDialog(data){
  this.getCurrentUsageForPromo(data);
  this.popupDialog = true;
  if(this.hasInsufficientSMSBalance()){
    this.popupDialogText = "Are your sure to send?";
    this.slotpropData = data;
  }else{
    this.popupDialogText = "Your SMS quota is insufficient to send messages to all uploaded numbers."
  }
  
}
popupDialogOkButton(){
  
  if(this.hasInsufficientSMSBalance()){
    this.sendSMSFromUI(this.slotpropData);
  }
  this.popupDialog = false;
  //this.smsSendConfirm = false;
}


private smsPackageData = {
    "package_id": 1, 
    "usage": "0",
    "status": "active",
};

private updatePackage(usageCount){
  this.findUsedPackages(usageCount);
  let usedPackagesCount = this.usedPackagesArray.length;
  for (let i = 0; i < usedPackagesCount; i++) {
    this.smsPackageData.package_id = this.usedPackagesArray[i].key1;
    this.smsPackageData.usage = this.usedPackagesArray[i].key2.toString();
    this.smsPackageData.status = this.usedPackagesArray[i].key3.toString();
    try {
        const response = this.SmsService.updateSmsPackage(this.smsPackageData);
        this.loadSMSPackages();
    } catch (error) {
    }
  }
  this.usedPackagesArray = []; 
  this.activePackagesArray = [];
};

loadCampainStatus(rowData){
  this.promotionalSMSService.requestCampaignStatus(rowData.id,rowData.transaction_id);
}
  
}


